import { z } from 'zod';
import * as formSystemRoutes from '@/shared/form-system/routes';

export const externalPageKeySchema = z.enum(['fgt-form-application']);
type ExternalPageKey = z.infer<typeof externalPageKeySchema>;

export const EXTERNAL_PAGE_ROUTES = {
  'fgt-form-application': formSystemRoutes.FORM_SYS_ROUTES.formApplication,
} as const satisfies Record<ExternalPageKey, string>;

export type ExternalTarget = (typeof EXTERNAL_PAGE_ROUTES)[ExternalPageKey];
